var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ManagementPage", {
    attrs: {
      pageName: _vm.$t("Data") + " / " + _vm.$t("GlobalSearch"),
      grid: ""
    },
    scopedSlots: _vm._u([
      {
        key: "top-left",
        fn: function() {
          return [_c("global-search-form")]
        },
        proxy: true
      },
      {
        key: "bottom-left",
        fn: function() {
          return [_c("global-search-map")]
        },
        proxy: true
      },
      {
        key: "top-right",
        fn: function() {
          return [_c("global-search-results")]
        },
        proxy: true
      },
      {
        key: "bottom-right",
        fn: function() {
          return [_c("global-search-workspaces")]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fb5eeac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fb5eeac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/GlobalSearchView.vue
// module id = null
// module chunks = 